import React, { useMemo } from 'react';
import {
  Card, Form, Row, Col,
} from 'react-bootstrap';
import Required from '../../Required';
import { Tooltip } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const default_labelsCfg = {
  influenceTechLabel: 'Влияние проекта на цели и задачи СТП',
  influenceTechPlaceholder: 'Краткое описание механизма влияния проекта на цель и задачи СТП',
  influenceGoalLabel: 'Влияние проекта на стратегическую цель развития (главную)',
  influenceGoalPlaceholder: 'Краткое описание механизма влияния проекта на стратегическую цель развития университета (главную)',
  goaltLabel: 'Цель или решаемая проблема',
  goalPlaceholder: 'Краткое описание цели или решаемой проблемы в соответствии с информацией в Программе развития',
  solutionLabel: 'Предлагаемое решение',
  solutionPlaceholder: 'Предлагаемое решение проблемы. Заполняется в том случае, если информация записана в Программе развития',
  descrLabel: 'Описание способа реализации проекта',
  descrPlaceholder: 'Опишите особенности проекта, технологии и способы его реализации',
};

export default function Contents({ data, onChange, labelsCfg, disabled }) {
  const labels = useMemo(() => ({ ...default_labelsCfg, ...(labelsCfg || {}) }), [labelsCfg]);

  return (
    <Card className="mb-4">
      <Card.Header as={Card.Title} className="p-4">Содержание</Card.Header>
      <Card.Body className="p-4">
        {data.strategy?.type === 'tech' && (
          <Row className="mb-4">
            <Form.Group as={Col}>
              <Form.Label>
                {labels.influenceTechLabel}
                {' '}
                <Required />
                {' '}
                <Tooltip
                  placement="top"
                  title={<p style={{ fontSize: 12 }}>{labels.influenceTechPlaceholder}</p>}
                  interactive
                >
                  <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
                </Tooltip>
              </Form.Label>
              <Form.Control
                placeholder={labels.influenceTechPlaceholder}
                required
                as="textarea"
                rows={3}
                value={data.influenceOnTechDescr}
                onChange={(elem) => onChange(elem.target.value, 'influenceOnTechDescr')}
                disabled={disabled}
              />
              <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
            </Form.Group>
          </Row>
        )}
        {data.strategy?.type === 'goal' && (
          <Row className="mb-4">
            <Form.Group as={Col}>
              <Form.Label>
                {labels.influenceGoalLabel}
                {' '}
                <Required />
                {' '}
                <Tooltip
                  placement="top"
                  title={<p style={{ fontSize: 12 }}>{labels.influenceGoalPlaceholder}</p>}
                  interactive
                >
                  <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
                </Tooltip>
              </Form.Label>
              <Form.Control
                placeholder={labels.influenceGoalPlaceholder}
                required
                as="textarea"
                rows={3}
                value={data.influenceOnGoalDescr}
                onChange={(elem) => onChange(elem.target.value, 'influenceOnGoalDescr')}
                disabled={disabled}
              />
              <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
            </Form.Group>
          </Row>
        )}
        <Row className="mb-4">
          <Form.Group as={Col}>
            <Form.Label>
              {labels.goaltLabel}
              {' '}
              <Required />
              {' '}
              <Tooltip
                placement="top"
                title={<p style={{ fontSize: 12 }}>{labels.goalPlaceholder}</p>}
                interactive
              >
                <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
              </Tooltip>
            </Form.Label>
            <Form.Control
              placeholder={labels.goalPlaceholder}
              required
              as="textarea"
              rows={3}
              value={data.goal}
              onChange={(elem) => onChange(elem.target.value, 'goal')}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Row className="mb-4">
          <Form.Group as={Col}>
            <Form.Label>
              {labels.solutionLabel}
              {' '}
              <Tooltip
                placement="top"
                title={<p style={{ fontSize: 12 }}>{labels.solutionPlaceholder}</p>}
                interactive
              >
                <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
              </Tooltip>
            </Form.Label>
            <Form.Control
              placeholder={labels.solutionPlaceholder}
              as="textarea"
              rows={3}
              value={data.solution}
              onChange={(elem) => onChange(elem.target.value, 'solution')}
              disabled={disabled}
            />
          </Form.Group>
        </Row>
        {/* <Row className="mb-4">
          <Form.Group as={Col}>
            <Form.Label>
              Задачи
              <Required />
            </Form.Label>
            <Form.Control
              placeholder="Задачи представляют собой конкретные действия, приводящие к достижению цели."
              // required
              as="textarea"
              rows={3}
              value={data.tasks}
              onChange={(elem) => onChange(elem.target.value, 'tasks')}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
          </Form.Group>
        </Row> */}
        <Row>
          <Form.Group as={Col}>
            <Form.Label>
              {labels.descrLabel}
              {' '}
              <Required />
              {' '}
              <Tooltip
                placement="top"
                title={<p style={{ fontSize: 12 }}>{labels.descrPlaceholder}</p>}
                interactive
              >
                <HelpOutlineIcon style={{ opacity: '0.66'}} fontSize="inherit" />
              </Tooltip>
            </Form.Label>
            <Form.Control
              placeholder={labels.descrPlaceholder}
              required
              as="textarea"
              rows={3}
              value={data.descr}
              onChange={(elem) => onChange(elem.target.value, 'descr')}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
          </Form.Group>
        </Row>
      </Card.Body>
    </Card>
  );
}
